import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { BaseBlogCard } from '../BaseBlogCard';
import { formatDateToLocaleRu } from '../../templates/blog-post';

export const BlogCards = styled.div`
    display: flex;
    align-items: flex-start;
    width: calc(100% + 1rem);
    justify-content: start;
    flex-wrap: wrap;
    margin-left: -1rem;
    margin-top: 48px;
`;

export const BlogCardsWrapper = styled.div`
    display: flex;
    align-self: stretch;
    box-sizing: border-box;
    margin-bottom: 48px;
    margin-left: 1rem;
    flex: 0 0 calc(100% / 3 - 1rem);
    width: calc(100% / 3 - 1rem);
    a {
        width: 100%;
    }

    @media screen and (max-width: 920px) {
        flex: calc(100% / 2 - 1rem);
        width: calc(100% / 2 - 1rem);
        margin-bottom: 32px;
    }

    @media screen and (max-width: 760px) {
        flex: calc(100% - 1rem);
        width: calc(100% - 1rem);
        margin-bottom: 0;
    }
`;

export const BlogCardsWrapperWide = styled(BlogCardsWrapper)`
    flex: 0 0 calc(100% / 3 * 2 - 1rem);
    width: calc(100% / 3 * 2 - 1rem);

    @media screen and (max-width: 920px) {
        flex: 0 0 calc(100% - 1rem);
        width: calc(100% - 1rem);
        margin-bottom: 32px;
        height: 290px;
    }
`;

export const BlogCardsComponent = ({ postsArray }) => {
    return (
        <BlogCards>
            {postsArray.map(
                (
                    {
                        frontmatter: { date, title, url },
                        id,
                        small,
                        medium,
                        cloudImage,
                        smallBackground,
                    },
                    i,
                    ar
                ) => {
                    const isWide = i === 0 && ar.length > 3;
                    const Wrapper = isWide
                        ? BlogCardsWrapperWide
                        : BlogCardsWrapper;
                    return (
                        <Wrapper key={id}>
                            <Link to={`/blog/${url}`}>
                                <BaseBlogCard
                                    title={title}
                                    date={formatDateToLocaleRu(date)}
                                    smallImage={
                                        small ? small.fluid : cloudImage.fluid
                                    }
                                    mediumImage={
                                        medium ? medium.fluid.src : null
                                    }
                                    smallBackground={
                                        smallBackground
                                            ? smallBackground.fluid.src
                                            : null
                                    }
                                    isWide={isWide}
                                />
                            </Link>
                        </Wrapper>
                    );
                }
            )}
        </BlogCards>
    );
};
